<template>
  <div class="matinees-soirees-wrap">
    <div class="container mx-auto px-6">

      <h2 class="text-3xl font-bold text-center mb-8 text-yellow-700 uppercase">
        Matinées / Soirées Théologiques
      </h2>

      <div class="content-text">

        <p class="mb-4">
          Les matinées et soirées théologiques sont des moments de grande ferveur intellectuelle 
          autour d’échanges théologiques en modalité interdisciplinaire. Ouvertes à tous ou avec 
          invités ciblés, elles permettent de vifs échanges entre professionnels ou experts sur des 
          sujets d’actualités.
        </p>

        <div class="event mb-6">
          <h4 class="font-semibold text-lg mb-2">28 novembre 2020</h4>
          <p>
            « L’avenir des cultures africaines entre déconstruction et construction. 
            Déconstruction et reconstruction des cultures africaines : nécessité et méthodes ».
          </p>
          <p>
            Une belle opportunité de réflexions d’application de la Ratio recta, l’orthos logos à la culture africaine afin de participer à son avenir : 
            l’homme est fils et père de la culture. La culture fait l’homme et la culture se fait par l’homme. 
            L’Eglise et la foi chrétienne ne sont pas opposées à la culture. C’est leur rôle de travailler à la purification et l’assomption de la culture.
          </p>
          <p>
            <strong>Conférencier :</strong> Le Père Antoine Marie Guy d’OLIVEIRA, docteur en Philosophie.<br/>
            <strong>Débat :</strong> Prof. Désiré MEDEGNON et Père Louis HONDOCODO.
          </p>
        </div>

        <div class="event mb-6">
          <h4 class="font-semibold text-lg mb-2">7 septembre 2019</h4>
          <p>
            L’appel de Kampala : Ecclesia in Africa ; gaudium et spes, luctus et angor, en mémoire des 50 ans de la visite de Paul VI à Kampala.
          </p>
          <p>
            « Africains, vous êtes désormais vos propres missionnaires. Vous pouvez et vous devez avoir un christianisme africain ».
          </p>
          <ul class="list-disc ps-4">
            <li>« Faire la théologie aujourd’hui en Afrique : esquisse d’une approche méthodologique », par le Père Rodrigue Gbédjinou.</li>
            <li>« Le SCEAM, instrument ecclésial de communion ? Les enjeux de la communion au sein de l’Eglise », par le Père Moïse Adékambi.</li>
            <li>« Les défis et nouveaux visages de la mission en Afrique aujourd’hui », Pasteure Fifamè Fidèle Houssou Gandonou et Père Laurent Kpogo.</li>
          </ul>
          <p>
            L’inédit de cette matinée fut le passionnant débat contradictoire entre Pères Edouard Adè et Nathanaël Soédé.
          </p>
        </div>

        <div class="event mb-6">
          <h4 class="font-semibold text-lg mb-2">15 septembre 2018</h4>
          <p>
            Fides et Ratio, 20 ans plus tard. Enjeux au regard des défis africains.
          </p>
          <ul class="list-disc ps-4">
            <li>Pères Colbert Goudjinou, Omer Dagan, Albert Nouhouayi, Grégoire Gainsi, Rodrigue Gbédjinou.</li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MatineesSoirees",
  setup() {
    return {};
  },
});
</script>

<style scoped>
.matinees-soirees-wrap {
  background-color: #fff;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.event {
  margin-bottom: 2rem;
}

h2 {
  color: #2b3a67;
}

.content-text ul {
  list-style-type: disc;
  padding-left: 1.5rem;
  line-height: 1.8;
}

.content-text p {
  margin-bottom: 1rem;
}
</style>
